// From the module, not the `@ui` barrel: this field is on club websites (newsletter
// consent), where the barrel's 38 files are dead weight.
import StyledCheckbox, { type StyledCheckboxProps } from '~/components/ui/Form/StyledCheckbox';
import { cx } from 'class-variance-authority';
import { ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { InputErrorMessage } from '../InputErrorMessage';

interface Props extends StyledCheckboxProps {
    name: string;
    label?: ReactNode;
    spacing?: number;
    className?: string;
    hideError?: boolean;
}

const FormCheckbox = ({ name, hideError, label, children, className, spacing, ...props }: Props) => {
    const { control } = useFormContext();
    const {
        field: { onChange, value, ...field },
        fieldState: { invalid }
    } = useController({ name, control, shouldUnregister: false });

    return (
        <div className={cx('tw-my-1', className)}>
            <StyledCheckbox
                {...props}
                {...field}
                value={name}
                isInvalid={invalid}
                isSelected={value}
                onChange={onChange}
            >
                {label || children}
            </StyledCheckbox>
            {!hideError && <InputErrorMessage name={name} />}
        </div>
    );
};

export default FormCheckbox;
